// extracted by mini-css-extract-plugin
var _1 = "SZywXlbr";
var _2 = "SZywXlbr";
var _3 = "KuDOU2b_";
var _4 = "zY3_kKIx";
var _5 = "YhtvnsRn";
var _6 = "NLQM1Q9l";
export { _1 as "footer-links", _2 as "footerLinks", _3 as "group", _4 as "groups", _5 as "links", _6 as "title" }
